module.exports = __webpack_public_path__ + "static/media/scale_default.29933c03.png";